import React from 'react';
import { IoCheckmarkCircle } from 'react-icons/io5';
import './BadgeItem.scss';

interface BadgeItemProps {
  nome: string;
  imagem: string;
  conquistado: boolean;
}

export const BadgeItem: React.FC<BadgeItemProps> = ({
  nome,
  imagem,
  conquistado
}) => {
  return (
    <div 
      className={`badge-item ${conquistado ? 'badge-item--conquistado' : ''}`}
      role="listitem"
      tabIndex={0}
      aria-label={`Badge: ${nome}. ${conquistado ? 'Conquistado' : 'Não conquistado'}`}
    >
      {conquistado && (
        <div className="badge-item__check" aria-hidden="true">
          <IoCheckmarkCircle size={24} />
        </div>
      )}
      <div className="badge-item__icone" aria-hidden="true">
        <img src={imagem} alt="" />
      </div>
      <p className="badge-item__nome" tabIndex={0}>{nome}</p>
    </div>
  );
};
